import API from './API';

const GeneralAPI = {
	getNumberAsText: value => API.get(`/number_text?value=${value}`),
	getTaxes: () => API.get('/taxes'),
};

export default GeneralAPI;
